<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">แจ้งเตือนพื้นที่บริการ WeServe</p>
    </header>
    <section class="modal-card-body">
      <div class="notification is-warning">
        <p class="has-text-weight-bold mb-3">⚠️ ประกาศสำคัญ</p>
        <p class="mb-3">
          บริการจัดส่ง WeServe <strong>ให้บริการเฉพาะในพื้นที่จังหวัดภูเก็ตเท่านั้น</strong>
        </p>
        <p class="mb-3">
          กรุณายืนยันว่าจุดหมายปลายทางของออเดอร์นี้อยู่ในพื้นที่จังหวัดภูเก็ตก่อนดำเนินการต่อ
        </p>
      </div>

      <div class="box">
        <p class="has-text-weight-bold mb-2">สาขา Villa Market ในจังหวัดภูเก็ต:</p>
        <ul class="branch-list">
          <li v-for="branch in phuketBranches" :key="branch">
            <b-icon icon="map-marker" size="is-small"></b-icon>
            {{ branch }}
          </li>
        </ul>
      </div>

      <b-field>
        <b-checkbox v-model="dontShowAgain">
          ไม่ต้องแสดงข้อความนี้อีกเป็นเวลา 24 ชั่วโมง
        </b-checkbox>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button @click="$emit('close')">ยกเลิก</b-button>
      <b-button type="is-primary" @click="handleProceed">
        ดำเนินการสร้างออเดอร์
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "WeServeWarningDialog",
  data() {
    return {
      dontShowAgain: false,
      phuketBranches: [
        "Boat Lagoon",
        "Chalong",
        "Laguna",
        "Homepro Cherngtalay",
        "Kamala",
        "Bukis"
      ]
    };
  },
  methods: {
    handleProceed() {
      if (this.dontShowAgain) {
        // Store timestamp in localStorage for 24-hour dismissal
        const expiryTime = Date.now() + 24 * 60 * 60 * 1000; // 24 hours from now
        localStorage.setItem("weserveWarningDismissed", expiryTime.toString());
      }
      this.$emit("proceed");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-card {
  min-width: 450px;
}

.notification {
  border-left: 4px solid #ff9800;
}

.branch-list {
  list-style: none;
  padding-left: 0;
}

.branch-list li {
  padding: 0.25rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.box {
  background-color: #f5f5f5;
}
</style>
